import { Component, Input } from '@angular/core';

@Component({
  selector: 'mom-progress-logo',
  templateUrl: 'progress-logo.component.html',
  styleUrls: ['./progress-logo.component.scss']
})
export class ProgressLogoComponent {
  @Input() progress = 0;
}
